import React from 'react';
import { TrError } from '@oforce/global-components';

export default function TrGraphQLErrors({ error, colSpan, ...rest }) {
  const errors = error ? error.graphQLErrors.map(e => e.message) : [];
  return error ? <TrError colSpan={colSpan} error={errors} {...rest} /> : null;
}
